export function modulo(divident: string, divisor: number): number {
  const partLength = 10;

  while (divident.length > partLength) {
    const part = divident.substring(0, partLength);
    divident = (Number(part) % divisor) + divident.substring(partLength);
  }
  return Number(divident) % divisor;
}
